module.exports = __webpack_public_path__ + "static/media/animated_zaid.3c8c72f8.png";